// import external dependencies
import 'promise-polyfill/src/polyfill'
import 'jquery'

// Import everything from autoload


// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import blog from './routes/blog'
import careers from './routes/careers'
import resources from './routes/resources'
import partners from './routes/partners'
import news from './routes/news'
import gatedAssets from './routes/gated-assets'
import search from './routes/search'
import './blocks'
import './components'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // blog page
  blog,
  // careers page
  careers,
  // news and resources listing page
  resources,
  partners,
  news,
  // gated assets listing page
  gatedAssets,
  // search page
  search,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js